import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsSatDot1Component } from './simple-icons-sat-dot-1.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsSatDot1Component ],
    exports:      [ SimpleIconsSatDot1Component ],
    bootstrap:    []
})
export class SimpleIconsSatDot1Module {}
